"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollapsibleWrapper = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var useDomRect_1 = require("powerhooks/useDomRect");
var evt_1 = require("evt");
var hooks_1 = require("evt/hooks");
var getScrollableParent_1 = require("powerhooks/getScrollableParent");
var ThemeProvider_1 = require("./lib/ThemeProvider");
var compat_1 = require("tss-react/compat");
exports.CollapsibleWrapper = react_1.memo(function (props) {
    var className = props.className, _a = props.transitionDuration, transitionDuration = _a === void 0 ? 250 : _a, children = props.children, rest = __rest(props, ["className", "transitionDuration", "children"]);
    var _b = useDomRect_1.useDomRect(), childrenWrapperRef = _b.ref, childrenWrapperHeight = _b.domRect.height;
    var _c = __read(react_1.useState(false), 2), isCollapsedIfDependsOfScroll = _c[0], setIsCollapsedIfDependsOfScroll = _c[1];
    hooks_1.useEvt(function (ctx) {
        var childrenWrapperElement = childrenWrapperRef.current;
        if (!childrenWrapperElement) {
            return;
        }
        if (rest.behavior !== "collapses on scroll") {
            return;
        }
        if (childrenWrapperHeight === 0) {
            return;
        }
        var scrollTopThreshold = rest.scrollTopThreshold;
        var scrollElement = getScrollableParent_1.getScrollableParent({
            "element": childrenWrapperElement,
            "doReturnElementIfScrollable": false,
        });
        evt_1.Evt.from(ctx, scrollElement, "scroll")
            .toStateful()
            .pipe(function () { return [scrollElement.scrollTop]; })
            .attach(function (scrollTop) {
            return setIsCollapsedIfDependsOfScroll(function (isCollapsed) {
                return isCollapsed
                    ? scrollTop + childrenWrapperHeight * 1.3 >
                        scrollTopThreshold
                    : scrollTop > scrollTopThreshold;
            });
        });
    }, __spreadArray([
        childrenWrapperRef.current
    ], __read((rest.behavior !== "collapses on scroll"
        ? [null, null]
        : [rest.scrollTopThreshold, childrenWrapperHeight]))));
    var _d = useStyles({
        "isCollapsed": (function () {
            switch (rest.behavior) {
                case "collapses on scroll":
                    return isCollapsedIfDependsOfScroll;
                case "controlled":
                    return rest.isCollapsed;
            }
        })(),
        childrenWrapperHeight: childrenWrapperHeight,
        transitionDuration: transitionDuration,
    }), classes = _d.classes, cx = _d.cx;
    classes = compat_1.useMergedClasses(classes, props.classes);
    return (jsx_runtime_1.jsx("div", __assign({ className: cx(classes.root, className) }, { children: jsx_runtime_1.jsxs("div", __assign({ className: classes.inner, ref: childrenWrapperRef }, { children: [children, jsx_runtime_1.jsx("div", { className: classes.bottomDivForSpacing }, void 0)] }), void 0) }), void 0));
});
var useStyles = ThemeProvider_1.makeStyles({ "name": { CollapsibleWrapper: exports.CollapsibleWrapper } })(function (_theme, _a) {
    var childrenWrapperHeight = _a.childrenWrapperHeight, isCollapsed = _a.isCollapsed, transitionDuration = _a.transitionDuration;
    return ({
        "root": {
            "height": isCollapsed ? 0 : childrenWrapperHeight || undefined,
            "opacity": isCollapsed ? 0 : 1,
            "transition": ["height", "padding", "margin", "opacity"]
                .map(function (prop) { return prop + " " + transitionDuration + "ms"; })
                .join(", "),
            "overflow": "hidden",
        },
        "inner": {},
        "bottomDivForSpacing": {
        //height: 30
        },
    });
});
//# sourceMappingURL=CollapsibleWrapper.js.map